import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      category: 'Booking',
      questions: [
        {
          q: 'How do I book an apartment?',
          a: 'Simply browse our apartments, select your dates and number of guests, and follow the booking process. You can pay securely online using your credit card.'
        },
        {
          q: 'What is the minimum stay requirement?',
          a: 'Minimum stay requirements vary by apartment, typically ranging from 1-3 nights. Check the specific apartment listing for details.'
        },
        {
          q: 'Can I modify or cancel my booking?',
          a: 'Yes, you can modify or cancel your booking through your account dashboard. Please review our cancellation policy for any applicable fees.'
        },
        {
          q: 'When will I receive my booking confirmation?',
          a: 'You\'ll receive an instant email confirmation once your booking is complete with all the details you need for your stay.'
        }
      ]
    },
    {
      category: 'Check-in & Check-out',
      questions: [
        {
          q: 'What time is check-in and check-out?',
          a: 'Standard check-in is from 3:00 PM and check-out is by 11:00 AM. Early check-in or late check-out may be available upon request.'
        },
        {
          q: 'How do I access the apartment?',
          a: 'You\'ll receive detailed access instructions including entry codes or key collection details 24-48 hours before your arrival.'
        },
        {
          q: 'Can I arrange early check-in?',
          a: 'Early check-in may be available subject to apartment availability. Please contact us at least 24 hours before your arrival to request.'
        }
      ]
    },
    {
      category: 'Apartments & Amenities',
      questions: [
        {
          q: 'Are the apartments fully furnished?',
          a: 'Yes, all apartments are fully furnished with modern amenities including fully-equipped kitchens, WiFi, TV, linens, and towels.'
        },
        {
          q: 'Is WiFi included?',
          a: 'Yes, high-speed WiFi is included free of charge in all our apartments.'
        },
        {
          q: 'Are pets allowed?',
          a: 'Pet policies vary by apartment. Check the specific listing or contact us to confirm if your pet is welcome.'
        },
        {
          q: 'Is there parking available?',
          a: 'Parking availability varies by location. Check the apartment listing for parking details or contact us for assistance.'
        }
      ]
    },
    {
      category: 'Payment & Pricing',
      questions: [
        {
          q: 'What payment methods do you accept?',
          a: 'We accept all major credit and debit cards through our secure payment gateway.'
        },
        {
          q: 'Are there any additional fees?',
          a: 'Our pricing is transparent. Any cleaning fees or service charges are clearly shown before you confirm your booking.'
        },
        {
          q: 'Do you offer discounts for longer stays?',
          a: 'Yes! We offer weekly (7+ nights) and monthly (28+ nights) discounts. These are automatically applied during booking.'
        }
      ]
    }
  ];

  const styles = {
    header: {
      background: '#f7f7f7',
      padding: '60px 24px',
      textAlign: 'center'
    },
    title: { fontSize: '2.5rem', fontWeight: '700', marginBottom: '16px' },
    subtitle: { color: '#555', maxWidth: '600px', margin: '0 auto' },
    container: { maxWidth: '800px', margin: '0 auto', padding: '60px 24px' },
    category: { marginBottom: '40px' },
    categoryTitle: {
      fontSize: '1.25rem',
      fontWeight: '600',
      color: '#1a3a5c',
      marginBottom: '16px'
    },
    faqItem: {
      borderBottom: '1px solid #eee',
      marginBottom: '8px'
    },
    question: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '16px 0',
      cursor: 'pointer',
      fontWeight: '500'
    },
    answer: {
      padding: '0 0 16px',
      color: '#555',
      lineHeight: '1.6'
    }
  };

  return (
    <>
      <header style={styles.header}>
        <h1 style={styles.title}>Frequently Asked Questions</h1>
        <p style={styles.subtitle}>
          Find answers to common questions about booking and staying with Kasbia Stays
        </p>
      </header>

      <section style={styles.container}>
        {faqs.map((category, catIdx) => (
          <div key={catIdx} style={styles.category}>
            <h2 style={styles.categoryTitle}>{category.category}</h2>
            {category.questions.map((faq, idx) => {
              const globalIdx = catIdx * 10 + idx;
              const isOpen = openIndex === globalIdx;

              return (
                <div key={idx} style={styles.faqItem}>
                  <div
                    style={styles.question}
                    onClick={() => setOpenIndex(isOpen ? -1 : globalIdx)}
                  >
                    <span>{faq.q}</span>
                    {isOpen ? <FiChevronUp /> : <FiChevronDown />}
                  </div>
                  {isOpen && <div style={styles.answer}>{faq.a}</div>}
                </div>
              );
            })}
          </div>
        ))}

        <div style={{ marginTop: '40px', padding: '24px', background: '#f7f7f7', borderRadius: '12px', textAlign: 'center' }}>
          <h3 style={{ fontWeight: '600', marginBottom: '12px' }}>Still have questions?</h3>
          <p style={{ color: '#555', marginBottom: '16px' }}>
            Our team is here to help you with any questions you may have.
          </p>
          <a href="/contact" style={{
            display: 'inline-block',
            background: '#1a3a5c',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            fontWeight: '500',
            textDecoration: 'none'
          }}>
            Contact Us
          </a>
        </div>
      </section>
    </>
  );
};

export default FAQ;
